import React, { useCallback } from 'react';
import { CheckIcon, Flex, List, Text } from '@landr/maestro';
import { useSearchModifiers } from 'controllers/SearchController/hooks/useSearchModifiers';
import { useCurrentSearchState } from 'controllers/SearchController/hooks/useCurrentSearchState';
import { FiltersParams } from 'types/params';
import { Trans } from '@lingui/macro';
import { useFiltersContext } from 'components/Filters/context/FiltersContext/FiltersContext';
import { searchV3FilterType } from 'components/Filters/Filters';
import useSearchTools from '../hooks/useSearchTools';

const TypeFiltersContent = ({ onClose }: { onClose?: () => void }) => {
    const { addFilter } = useSearchModifiers();
    const { listOfTypes } = useFiltersContext();
    const { type: typeState } = useCurrentSearchState();
    const { clearFilter } = useSearchTools({
        toolsType: searchV3FilterType.Types,
    });

    const setTypeFilter = useCallback(
        (code: string) => {
            code && addFilter([[FiltersParams.type, code]]);
        },
        [addFilter],
    );

    return (
        <List width="100%">
            <List.Item
                key={'Loop & One-shot'}
                onClick={() => {
                    clearFilter();
                    onClose && onClose();
                }}
                width="100%"
            >
                <Flex
                    alignItems={'center'}
                    justifyContent={'space-between'}
                    width="100%"
                >
                    <Text>
                        <Trans>Loop & One-shot</Trans>
                    </Text>

                    {typeState === null && <CheckIcon />}
                </Flex>
            </List.Item>
            <List.Item
                key={'Loop'}
                onClick={() => {
                    setTypeFilter(listOfTypes?.list?.[0]?.code ?? '');
                    onClose && onClose();
                }}
                width="100%"
            >
                <Flex
                    alignItems={'center'}
                    justifyContent={'space-between'}
                    width="100%"
                >
                    <Text>
                        <Trans>Loop</Trans>
                    </Text>

                    {typeState === listOfTypes?.list?.[0]?.code && (
                        <CheckIcon />
                    )}
                </Flex>
            </List.Item>
            <List.Item
                key={'One-shot'}
                onClick={() => {
                    setTypeFilter(listOfTypes?.list?.[1]?.code ?? '');
                    onClose && onClose();
                }}
                width="100%"
            >
                <Flex
                    alignItems={'center'}
                    justifyContent={'space-between'}
                    width="100%"
                >
                    <Text>
                        <Trans>One-shot</Trans>
                    </Text>

                    {typeState === listOfTypes?.list?.[1]?.code && (
                        <CheckIcon />
                    )}
                </Flex>
            </List.Item>
        </List>
    );
};

export default TypeFiltersContent;
